// extracted by mini-css-extract-plugin
export default {"container":"OverviewDashboard_container__NkJOL","statistics":"OverviewDashboard_statistics__YJ4Wb"};